export default __webpack_public_path__ + "static/media/downArrow.b3e8292a.svg";